import type {Context} from '../types';

const typesToChangeToBlock: Record<string, boolean> = {
  CommerceCheckoutForm: true,
  CommerceCheckoutSummaryColumnLeft: true,
  CommerceCheckoutSummaryColumnRight: true,
};

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {type} = jsonNode;
  const needed = Boolean(type && typesToChangeToBlock[type]);

  return {
    needed,
    logData: {
      msg: 'Legacy Ecommerce element needs type change to Block',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.type = 'Block';
    },
  };
};
